// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-cell {
  line-height: 1 !important;
  padding: 0.25rem 0.75rem !important;
  border-right: 1px solid #d3d3d3c2;
}

/* Special styling for patient name column to align with header */

.col-pat-name {
  padding: 0 !important;
  margin-left: -0.1875rem !important;
}

/* ===== My Worklist — Filter Section (page-specific) ===== */

.wl-filters-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.wl-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-width: 0;
}

.wl-field--name      { width: 9.6875rem; }

.wl-field--status    { width: 8.125rem; }

.wl-field--body      { width: 9.0625rem; }

.wl-field--site      { width: 7.5rem; }

.wl-field--ordno     { width: 7.1875rem; }

.wl-field--hisstatus { width: 7.5rem; }

.wl-field--refdoc    { width: 8.125rem; }

.wl-field--date      { width: auto; }

.wl-filters-row .ant-input,
.wl-filters-row .ant-picker,
.wl-filters-row .ant-select {
  width: 100% !important;
}

/* Study-date selector with the quick-preset chips (1D, 2D, 1W ...) beside it.
   nowrap keeps the chips locked to the right of the picker instead of dropping
   onto a second line when the filter row gets tight. */

.date-with-presets {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.5rem;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}

/* Put the study-date picker + preset chips together on their own full-width
   line, below the other filter fields (keeps the old two-row field layout). */

.wl-filters-row .wl-field--date {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
          flex: 0 0 100%;
}

.wl-filters-row .date-with-presets .ant-picker {
  width: 18.125rem !important;
}

.priority-pills-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 0.5rem;
}

.priority-pills-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.5rem;
}

.priority-pill {
  padding: 0.25rem 0.75rem;
  height: 1.875rem;
  border: 1px solid #D1D5DB;
  border-radius: 0.5rem;
  background: #FFFFFF;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.priority-pill:hover {
  border-color: #9CA3AF;
  background: #F9FAFB;
}

.priority-pill.selected {
  background: #F7EFFF;
  border: 1px solid #7D48B0;
  color: #400A73;
}

/* Fixed widths for large screens */

.priority-pill-all {
  width: 7.0625rem;
}

.priority-pill-asap {
  width: 3.875rem;
}

.priority-pill-normal {
  width: 4.5rem;
}

.priority-pill-emergency {
  width: 6.4375rem;
}

/* Show full text on large screens, hide short text */

.pill-text-full {
  display: inline;
}

.pill-text-short {
  display: none;
}

/* For medium and small screens (≤1200px): Make pills take full width */

@media (max-width: 1200px) {
  .priority-pill-all,
  .priority-pill-asap,
  .priority-pill-normal,
  .priority-pill-emergency {
    width: 100% !important;
  }

  /* Hide full text, show short text on smaller screens */
  .pill-text-full {
    display: none;
  }

  .pill-text-short {
    display: inline;
  }
}

/* Action-column icons: tinted hover pill matching each icon's hue (set per-icon
   via --ai-hover) and a muted, not-allowed disabled state. Mirrors the PACS
   table so the radiologist/typist worklist reads the same. */

.action-icon-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
  min-width: 24px;
  min-height: 24px;
}

.action-icon-button:hover {
  background-color: var(--ai-hover, #eef1f5);
}

.action-icon-button.disabled {
  /* Flat icon self-fades when disabled; wrapper only sets the cursor. */
  cursor: not-allowed;
}

.action-icon-button.disabled:hover {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./pages/my-workilist/worklist.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA,iEAAiE;;AACjE;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,6DAA6D;;AAC7D;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;AACd;;AAEA,uBAAuB,gBAAgB,EAAE;;AACzC,uBAAuB,eAAe,EAAE;;AACxC,uBAAuB,gBAAgB,EAAE;;AACzC,uBAAuB,aAAa,EAAE;;AACtC,uBAAuB,gBAAgB,EAAE;;AACzC,uBAAuB,aAAa,EAAE;;AACtC,uBAAuB,eAAe,EAAE;;AACxC,uBAAuB,WAAW,EAAE;;AAEpC;;;EAGE,sBAAsB;AACxB;;AAEA;;uDAEuD;;AACvD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,qBAAiB;MAAjB,iBAAiB;AACnB;;AAEA;8EAC8E;;AAC9E;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mCAAmC;;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qDAAqD;;AACrD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,uEAAuE;;AACvE;EACE;;;;IAIE,sBAAsB;EACxB;;EAEA,uDAAuD;EACvD;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;6DAE6D;;AAC7D;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAAsC;EAAtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".ant-table-cell {\r\n  line-height: 1 !important;\r\n  padding: 0.25rem 0.75rem !important;\r\n  border-right: 1px solid #d3d3d3c2;\r\n}\r\n\r\n/* Special styling for patient name column to align with header */\r\n.col-pat-name {\r\n  padding: 0 !important;\r\n  margin-left: -0.1875rem !important;\r\n}\r\n\r\n/* ===== My Worklist — Filter Section (page-specific) ===== */\r\n.wl-filters-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.wl-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.wl-field--name      { width: 9.6875rem; }\r\n.wl-field--status    { width: 8.125rem; }\r\n.wl-field--body      { width: 9.0625rem; }\r\n.wl-field--site      { width: 7.5rem; }\r\n.wl-field--ordno     { width: 7.1875rem; }\r\n.wl-field--hisstatus { width: 7.5rem; }\r\n.wl-field--refdoc    { width: 8.125rem; }\r\n.wl-field--date      { width: auto; }\r\n\r\n.wl-filters-row .ant-input,\r\n.wl-filters-row .ant-picker,\r\n.wl-filters-row .ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n/* Study-date selector with the quick-preset chips (1D, 2D, 1W ...) beside it.\r\n   nowrap keeps the chips locked to the right of the picker instead of dropping\r\n   onto a second line when the filter row gets tight. */\r\n.date-with-presets {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n/* Put the study-date picker + preset chips together on their own full-width\r\n   line, below the other filter fields (keeps the old two-row field layout). */\r\n.wl-filters-row .wl-field--date {\r\n  flex: 0 0 100%;\r\n}\r\n\r\n.wl-filters-row .date-with-presets .ant-picker {\r\n  width: 18.125rem !important;\r\n}\r\n\r\n\r\n.priority-pills-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.priority-pills-row {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.priority-pill {\r\n  padding: 0.25rem 0.75rem;\r\n  height: 1.875rem;\r\n  border: 1px solid #D1D5DB;\r\n  border-radius: 0.5rem;\r\n  background: #FFFFFF;\r\n  font-family: Inter, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.priority-pill:hover {\r\n  border-color: #9CA3AF;\r\n  background: #F9FAFB;\r\n}\r\n\r\n.priority-pill.selected {\r\n  background: #F7EFFF;\r\n  border: 1px solid #7D48B0;\r\n  color: #400A73;\r\n}\r\n\r\n/* Fixed widths for large screens */\r\n.priority-pill-all {\r\n  width: 7.0625rem;\r\n}\r\n\r\n.priority-pill-asap {\r\n  width: 3.875rem;\r\n}\r\n\r\n.priority-pill-normal {\r\n  width: 4.5rem;\r\n}\r\n\r\n.priority-pill-emergency {\r\n  width: 6.4375rem;\r\n}\r\n\r\n/* Show full text on large screens, hide short text */\r\n.pill-text-full {\r\n  display: inline;\r\n}\r\n\r\n.pill-text-short {\r\n  display: none;\r\n}\r\n\r\n/* For medium and small screens (≤1200px): Make pills take full width */\r\n@media (max-width: 1200px) {\r\n  .priority-pill-all,\r\n  .priority-pill-asap,\r\n  .priority-pill-normal,\r\n  .priority-pill-emergency {\r\n    width: 100% !important;\r\n  }\r\n\r\n  /* Hide full text, show short text on smaller screens */\r\n  .pill-text-full {\r\n    display: none;\r\n  }\r\n\r\n  .pill-text-short {\r\n    display: inline;\r\n  }\r\n}\r\n\r\n/* Action-column icons: tinted hover pill matching each icon's hue (set per-icon\r\n   via --ai-hover) and a muted, not-allowed disabled state. Mirrors the PACS\r\n   table so the radiologist/typist worklist reads the same. */\r\n.action-icon-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  min-width: 24px;\r\n  min-height: 24px;\r\n}\r\n\r\n.action-icon-button:hover {\r\n  background-color: var(--ai-hover, #eef1f5);\r\n}\r\n\r\n.action-icon-button.disabled {\r\n  /* Flat icon self-fades when disabled; wrapper only sets the cursor. */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.action-icon-button.disabled:hover {\r\n  background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
